import { FC, DatePicker, registerDatePickerLocale, useMemo, useContext, CustomDateInput} from 'external/react'
import {clsx, styled} from 'external/material'
import {isAfter, locales, parseDate} from 'external/date-fns'
import { formatISO } from 'date-fns'
import { TeacherContext } from 'teacher/context'


Object.entries(locales).forEach(([languages, locale]) => registerDatePickerLocale(languages, locale))

export const StyledDatePicker = styled('div')(unitDurationStyles as any)

type UnitDurationProps = {
  className?: string
}

const UnitDuration: FC<UnitDurationProps> = props => {

  const {className} = props

  const {newPlan: plan, updateState, translate, languageId} = useContext(TeacherContext) as any

  const updatePlan = (commands: any) => updateState({newPlan: commands})

  const startDate= useMemo(() => parseDate(plan.start), [plan.start])
  const endDate= useMemo(() => parseDate(plan.finish), [plan.finish])

  return (
    <StyledDatePicker className={clsx("date-picker", className)}>
      <label className="label">
        {translate('planning-rd-unit-duration')}
      </label>
      <div className="components">
        <DatePicker
          customInput={<CustomDateInput />}
          selected={startDate}
          onChange={(date: any) => {
            const isoDate = formatISO(date)
            const updateDate = isAfter(endDate, date)
              ? ({start: {$set: isoDate}})
              : ({start: {$set: isoDate}, finish: {$set: isoDate}})
            updatePlan(updateDate)
          }}
          minDate={new Date()}
          maxDate={null}
          locale={languageId}
          popperPlacement="auto-start"
        />
        <div className="separator">-</div>
        <DatePicker
          customInput={<CustomDateInput />}
          selected={endDate}
          onChange={(date: any) => updatePlan({finish: {$set: formatISO(date)}})}
          minDate={startDate}
          maxDate={null}
          locale={languageId}
          popperPlacement="auto-start"
        />
      </div>
    </StyledDatePicker>
  )
}


function unitDurationStyles() {
  return {

       display: 'flex',
       flexDirection: 'column',
       gap: '10px',
      "& .label": {
        fontSize: '16px',
        color: '#4a4a4a',
        alignSelf: 'flex-start' 
      },
      "& .components": {
        display: 'flex',
        gap: '1rem',
        justifyContent: 'flex-start',
        width: '100%',
        "& .separator": {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'scaleX(1.5)'
        },
        "& .date-input": {
          cursor: 'pointer',
          width: '110px',
          padding: '6px 0',
          textAlign: 'center',
          border: 'solid 1px #b8c1c7'
        }
    }
  }
}

export {UnitDuration as default}